// extracted by mini-css-extract-plugin
module.exports = {"e13czwcs":"e13czwcs","tu0gn95":"tu0gn95"};